import Party from '../../models/Party'
import RidingResult from '../../models/RidingResult'

export interface ISeat {
  plan: {
    x: number
    y: number
  }
  num: number
  occupant: Party
}

class LegislaturePlan {
  // https://www.ourcommons.ca/Members/en/floorplan

  private _totalNumSeats = 0
  private _seatArray: ISeat[][]

  public static NUM_SEATS_PER_ROW = 29
  public static NUM_ROWS = 13

  public constructor() {
    this._seatArray = this.buildSeatArray()
  }

  public getSeatArray(): ISeat[] {
    return this._seatArray.flat()
  }

  public fillSeats(ridingResults: RidingResult[]): void {
    this.getSeatArray().forEach((seat, index): void => {
      seat.occupant = ridingResults[index].winner().party
    })
  }

  // With x = 0 and y = 0 in the BOTTOM LEFT, build an array of seats
  protected buildSeatArray(): ISeat[][] {
    const rowArray = new Array<ISeat[]>(LegislaturePlan.NUM_ROWS)

    for (let y = 0; y < LegislaturePlan.NUM_ROWS; y++) {
      console.log('y', y)
      rowArray[y] = this.buildRowArray(y)
    }

    return rowArray
  }

  protected buildRowArray(y: number): ISeat[] {
    const row: ISeat[] = []

    // Invert y value, because we fill the HOC from the bottom (!)
    y = LegislaturePlan.NUM_ROWS - y - 1

    // There are actually 345 seats in the HoC! Some are unoccupied. So we have
    // to adjust.
    const rowAdjustment: { [key: number]: number } = {
      0: -3,
      1: -2,
      2: -1,
      3: 0,
      4: 0,
      5: 0,
      6: -28,
      7: 0,
      8: 0,
      9: 0,
      10: -1,
      11: -2,
      12: -2
    }

    const rowSeatCount = LegislaturePlan.NUM_SEATS_PER_ROW + rowAdjustment[y]

    // The first five rows all have 30 seats, minus a factor based on the row #
    for (let x = 0; x < rowSeatCount; x++) {
      row.push({
        plan: { x, y },
        num: this._totalNumSeats++,
        occupant: Party.OTH
      })
    }

    return row
  }
}

export default LegislaturePlan
